import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./SafeDropdown.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretRight } from "@fortawesome/free-solid-svg-icons";
import lockIcon from "../../assets/Awesome_Lock.svg";
import { useTranslation } from "react-i18next";

/*
 * When clicked opens info about why inputting card information is safe.
 */
export function SafeDropdown({ onClick }) {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleOnClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(!isOpen);
    onClick();
  };

  return (
    <div className={styles.container} onClick={handleOnClick}>
      <div className={styles.content}>
        <button className={styles.arrow}>
          {!isOpen ? (
            <FontAwesomeIcon icon={faCaretRight} className={styles.arrowIcon} />
          ) : (
            <FontAwesomeIcon icon={faCaretDown} className={styles.arrowIcon} />
          )}
        </button>
        <span className={styles.lock}>
          {/* <FontAwesomeIcon icon={faLock} className={styles.lockIcon} /> */}
          <img src={lockIcon} alt="Lock Icon" />
        </span>
        <p>{t("Why is this safe")}</p>
      </div>

      {isOpen && (
        <div className={styles.description}>
          <p className={styles.safeText}>
            {t("WWG completed required procedures")}
          </p>
        </div>
      )}
    </div>
  );
}

SafeDropdown.propTypes = {
  onClick: PropTypes.func,
};
